import { Component, Input, Output, OnInit, OnDestroy, EventEmitter } from "@angular/core";
import { Subscription } from "rxjs";
import { MasterService } from "../master/services/master.service";
import { PersonSelectorService } from "./personselector.service";
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from "../../shared/services/user.service";
import { HttpclientService } from "../../shared";

declare var $: any;

@Component({
	selector: "caass-personselector",
	templateUrl: "./personselector.component.html",
	styleUrls: ["./personselector.css"],
})
export class PersonSelectorComponent implements OnInit, OnDestroy {
	@Output() onPersonChange: EventEmitter<any> = new EventEmitter<any>();

	constructor(private userService: UserService, private personSelectorService: PersonSelectorService, private masterService: MasterService) {
		this.user = this.userService.getCurrentUser();
		this.personSelectorService.ThumbnailRefreshObservable.subscribe((data) => this.ThumbnailRefresh(data));
	}

	public changePerson(selectedPersoninfo: any): void {
		selectedPersoninfo = this.selectedPerson;

		this.onPersonChange.emit(selectedPersoninfo);
	}

	user: any;

	@Input() buttonMultiSelectProcessCaption: any = "Process";
	@Input() MultiSelect: boolean = false;
	@Input() dialogForm: boolean = false;
	@Input() AudienceID: any = 1;
	@Input() CanSwitchAudience: any = false;
	@Input() ShowAllSchools: boolean = true;
	@Input() ShowProcessButton: boolean = true;
	@Input()
	InputApplicationItemID: string = "";

	@Input() InputSchoolID: any = 0;
	@Input() UpdateSchoolSelector: boolean = true;

	AudienceName: any = "Student";
	NameLabel: any = "Student";
	DesignatorLabel: any = "Student ID";
	errorMessage: any;
	selectedPerson: any;
	selectedPersonsList = [];
	personPicture: any;
	subscription: Subscription;
	masterRouteChangesubscription: Subscription;
	audienceIdChangedSubscription: Subscription;
	selectedValue = "val1";

	selectedMessage = "";

	subscriptionRefreshPerson: Subscription;
	subscriptionUnselectItems: Subscription;

	PersonLoading: boolean = false;
	PersonPhotoLoading: boolean = false;

	ngDestroy() {
		this.subscription.unsubscribe();
		this.masterRouteChangesubscription.unsubscribe();
		this.subscriptionRefreshPerson.unsubscribe();
		this.subscriptionUnselectItems.unsubscribe();
	}

	onAudienceSelected() {
		if (this.selectedValue == "val2") {
			this.NameLabel = "Staff";
			this.DesignatorLabel = "Staff ID";
			this.AudienceName = "Staff";
			this.AudienceID = 2;
		} else {
			this.AudienceName = "Student";
			this.NameLabel = "Student";
			this.DesignatorLabel = "Student ID";
			this.AudienceID = 1;
		}
		this.personSelectorService.changeAudienceId(this.AudienceID);
	}

	setClickedRow = function (personID) {
		// console.log("setClickedRow");
		// console.log(personID);

		this.personGet(personID);
		//this.personPhotoGet(personID);
	};

	selectRow(checkValue) {
		// console.log("selectRow");
		// console.log(checkValue);

		if (checkValue) {
			this.selectedPersonsList = this.persons;
		} else {
			this.selectedPersonsList = [];
		}
		this.setSelectedMessage(null);
	}
	setSelectedMessage(person) {
		// console.log("Set Selected Message");
		// console.log(person);

		this.selectedMessage = this.selectedPersonsList.length + " selected out of " + this.persons.length;

		if (person) {
			this.onRowSelect(person);
		}
	}
	onRowSelect(person) {
		let personID = person.PersonID;
		this.personGet(personID);
	}

	onRowUnselect(val) {
		this.selectedPerson = {
			PersonID: -1,
		};
	}

	paginate(event) {
		// console.log(event);

		this.selectedPerson = this.persons[event.first];
		this.personGet(this.selectedPerson.PersonID);
	}

	lastRow: any;

	persons: any = [];

	pageFirst = 0;

	pageRows = 8;
	totalRecord = 0;
	loading: boolean;
	loadData(params) {
		this.pageFirst = 0;

		this.loading = true;
		this.selectedMessage = "";

		this.selectedPersonsList = [];

		if (this.user.userID == 0 && (params.SchoolID == undefined || params.SchoolID <= 0)) {
			this.loading = false;
			return;
		}

		var result = this.personSelectorService.loadTablePerson(params);
		result.subscribe(
			(response) => {
				this.loading = false;
				this.persons = response;

				this.totalRecord = this.persons.length;
				if (this.totalRecord > 0) {
					this.selectedPerson = this.persons[0];
					this.personGet(this.selectedPerson.PersonID);
				} else {
					this.personGet(-1);
				}

				//////////////////////////////////////////////////////////////
				// Student Scan History
				//////////////////////////////////////////////////////////////
				this.personSelectorService.tableChanged(this.persons);
				//////////////////////////////////////////////////////////////
			},
			(error) => {}
		);
	}

	ClearPerson() {
		this.selectedPerson = null;
		this.personPicture = null;
	}

	personGet(personID) {
		this.PersonLoading = true;

		if (personID == undefined) {
			//console.log("Person Get Undefined");
			this.PersonLoading = false;
			return;
		}

		if (this.dialogForm) {
			this.PersonLoading = false;
			return;
		}

		if (personID < 0) {
			this.selectedPerson = {
				PersonID: -1,
			};

			this.changePerson(this.selectedPerson);
			this.personSelectorService.personSelectedChanged(this.selectedPerson);
			this.PersonLoading = false;
			return;
		}

		var result = this.personSelectorService.personGet(personID);
		result.subscribe(
			(response: any) => {
				this.PersonLoading = false;

				this.selectedPerson = response;

				if (response) {
					this.changePerson(this.selectedPerson);
				}
				this.personSelectorService.personSelectedChanged(response);
			},
			(error) => {
				this.PersonLoading = false;
			}
		);
	}

	personPhotoGet(personID) {
		var result = this.personSelectorService.personPhotoGet(personID);
		result.subscribe(
			(response: any) => {
				if (response) {
					this.personPicture = "data:image/jpg;base64," + response;
				} else {
					this.personPicture = "assets/images/nophotoavailable.jpg";
					//assets/images/CAASS_LOGO_NEW.png
				}
			},
			(error) => {}
		);
	}

	ProcessSelectedMultiplePersons() {
		let selectedPersonIds = this.selectedPersonsList.map(({ PersonID }) => PersonID);

		this.personSelectorService.ProcessSelectMultiplePersonId(selectedPersonIds);
	}
	ngOnInit(): void {
		//this.loadData()

		this.masterRouteChangesubscription = this.masterService.CheckRouteChange().subscribe((response) => {
			this.personSelectorService.personSelectedChanged(this.selectedPerson);
		});

		this.subscription = this.personSelectorService.onFilterChange().subscribe((response) => {
			this.loadData(response);
		});

		this.subscriptionRefreshPerson = this.personSelectorService.onRefreshPersonInfo().subscribe((personID) => {
			if (personID > 0) {
				this.personPhotoGet(personID);
			}
		});

		this.subscriptionUnselectItems = this.personSelectorService.onUnselectItems().subscribe(() => {
			this.selectedPersonsList = [];
			this.setSelectedMessage(null);
		});

		if (this.AudienceID == 2) {
			this.NameLabel = "Staff";
			this.DesignatorLabel = "Staff ID";
			this.AudienceName = "Staff";
		}

		this.audienceIdChangedSubscription = this.personSelectorService.onAudienceIdChange().subscribe((response) => {
			this.AudienceID = response;
		});
	}

	photoClick(personID) {
		this.personSelectorService.setPhotoClicked(personID);
	}

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscription.unsubscribe();
		this.subscriptionRefreshPerson.unsubscribe();
		this.subscriptionUnselectItems.unsubscribe();
		this.masterRouteChangesubscription.unsubscribe();
		this.audienceIdChangedSubscription.unsubscribe();
	}

	getCSSClasses(main) {
		let cssClasses;
		if (this.dialogForm) {
			cssClasses = {
				"col-sm-12": true,
				"col-lg-12": true,
			};
		} else {
			cssClasses = {
				"col-sm-6": true,
				"col-md-6": true,
				"col-lg-4": true,
			};
			if (main) {
				cssClasses = {
					"col-sm-6": true,
					"col-md-6": true,
					"col-lg-6": true,
				};
			}
		}
		return cssClasses;
	}

	getCheckBoxDisplay() {
		if (this.dialogForm || this.MultiSelect) {
			return "block";
		} else {
			return "none";
		}
	}

	RefreshSelectedPhoto() {
		if (this.selectedPerson == undefined) {
			return;
		}

		if (this.selectedPerson.PersonID <= 0) {
			return;
		}

		this.PersonPhotoLoading = true;

		var result = this.personSelectorService.RefreshPhotoGet(this.selectedPerson.PersonID);
		result.subscribe(
			(response) => {
				this.PersonPhotoLoading = false;

				this.selectedPerson.PersonPhotoUrl = response[0];
			},
			(error) => {
				this.PersonPhotoLoading = false;
			}
		);
	}

	ThumbnailRefresh(data: any) {
		if (data == "Refresh") {
			this.RefreshSelectedPhoto();
		}
	}
}
